import { HTMLAttributes } from "react";

export default function Redis(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.675 34.9125C43.1625 36.225 30.15 41.55 27.375 43.0125C24.6 44.475 23.0625 44.4375 20.8876 43.3875C18.7125 42.3375 4.87505 36.7875 2.36255 35.5875C1.12505 34.9875 0.487549 34.5 0.487549 34.0125V29.25C0.487549 29.25 18.4875 25.3125 21.4125 24.3C24.3375 23.25 25.3125 23.2125 27.7875 24.1125C30.2625 25.0125 45.075 27.675 47.5125 28.575V33.2625C47.5125 33.75 46.9501 34.275 45.675 34.9125Z"
        fill="#A41E11"
      />
      <path
        d="M45.675 30.1875C43.1625 31.5 30.15 36.825 27.375 38.2875C24.6 39.75 23.0625 39.7125 20.8875 38.6625C18.7125 37.6125 4.87499 32.025 2.36249 30.825C-0.112513 29.625 -0.187513 28.8 2.24999 27.8625C4.68749 26.8875 18.45 21.4875 21.375 20.475C24.3 19.425 25.275 19.3875 27.75 20.2875C30.225 21.1875 43.1625 26.325 45.6 27.225C48.1125 28.125 48.1875 28.875 45.675 30.1875Z"
        fill="#D82C20"
      />
      <path
        d="M45.675 27.1875C43.1625 28.5 30.15 33.825 27.375 35.2875C24.6 36.7125 23.0625 36.7125 20.8876 35.6625C18.7125 34.6125 4.87505 29.025 2.36255 27.825C1.12505 27.225 0.487549 26.7375 0.487549 26.25V21.4875C0.487549 21.4875 18.4875 17.55 21.4125 16.5375C24.3375 15.4875 25.3125 15.45 27.7875 16.35C30.2625 17.25 45.075 19.9125 47.5125 20.8125V25.5C47.5125 25.9875 46.9501 26.5125 45.675 27.1875Z"
        fill="#A41E11"
      />
      <path
        d="M45.6749 22.425C43.1624 23.7375 30.1499 29.0625 27.3749 30.525C24.5999 31.95 23.0624 31.95 20.8874 30.9C18.7124 29.85 4.87489 24.2625 2.36239 23.0625C-0.150111 21.8625 -0.187611 21.0375 2.24989 20.1C4.68739 19.125 18.4499 13.725 21.3749 12.7125C24.2999 11.6625 25.2749 11.625 27.7499 12.525C30.2249 13.425 43.1624 18.5625 45.5999 19.4625C48.1124 20.3625 48.1874 21.1125 45.6749 22.425Z"
        fill="#D82C20"
      />
      <path
        d="M45.6749 19.125C43.1624 20.4375 30.15 25.7625 27.375 27.225C24.6 28.65 23.0624 28.65 20.8874 27.6C18.7125 26.5875 4.87495 21 2.36245 19.8C1.12495 19.2 0.449951 18.7125 0.449951 18.225V13.4625C0.449951 13.4625 18.4499 9.525 21.3749 8.5125C24.2999 7.4625 25.275 7.425 27.75 8.325C30.225 9.225 45.0374 11.8875 47.4749 12.7875V17.475C47.5124 17.9625 46.95 18.45 45.6749 19.125Z"
        fill="#A41E11"
      />
      <path
        d="M45.6749 14.3625C43.1624 15.675 30.1499 21 27.3749 22.4625C24.5999 23.8875 23.0624 23.8875 20.8874 22.8375C18.7124 21.7875 4.87489 16.2375 2.36239 15.0375C-0.150111 13.8375 -0.187611 13.0125 2.24989 12.075C4.68739 11.1 18.4499 5.7 21.3749 4.6875C24.2999 3.6375 25.2749 3.6 27.7499 4.5C30.2249 5.4 43.1624 10.5375 45.5999 11.4375C48.1124 12.3375 48.1874 13.0875 45.6749 14.3625Z"
        fill="#D82C20"
      />
      <path
        d="M30.15 9.7875L26.1 10.2375L25.1625 12.4125L23.7 9.975L19.0125 9.5625L22.5 8.2875L21.45 6.3375L24.75 7.6125L27.8249 6.6L27 8.625L30.15 9.7875ZM24.9375 20.4375L17.325 17.2875L28.2375 15.6375L24.9375 20.4375Z"
        fill="white"
      />
      <path
        d="M14.3999 15.525C17.6101 15.525 20.2124 14.5176 20.2124 13.275C20.2124 12.0324 17.6101 11.025 14.3999 11.025C11.1897 11.025 8.5874 12.0324 8.5874 13.275C8.5874 14.5176 11.1897 15.525 14.3999 15.525Z"
        fill="white"
      />
      <path
        d="M34.9875 10.3875L41.4375 12.9375L34.9875 15.4875V10.3875Z"
        fill="#7A0C00"
      />
      <path
        d="M27.8625 13.2375L34.9875 10.3875V15.4875L34.275 15.7875L27.8625 13.2375Z"
        fill="#AD2115"
      />
    </svg>
  )
}
